import { formatPageTitle, resolvePageTitle } from "@ubif/util-store";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = formatPageTitle(resolvePageTitle(pathname));
  }, [pathname]);
}
